import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./Eyebrow.module.css";

export interface EyebrowProps extends React.ComponentPropsWithoutRef<"span"> {
  as?: "span" | "p" | "div" | "dt";
  tone?: "muted" | "brand" | "strong";
  /** JetBrains Mono 11: el rótulo de un token o de una sección del catálogo. */
  mono?: boolean;
}

/** La etiqueta chica en mayúsculas sobre un título o un dato (`ORIGEN DEL CONTACTO`). Es el único uso de mayúsculas que admite la marca. */
export function Eyebrow({ as = "span", tone = "muted", mono, className, ...rest }: EyebrowProps) {
  const Tag = as as React.ElementType;
  return <Tag className={cx(s.eyebrow, className)} data-tone={tone} data-mono={mono || undefined} {...rest} />;
}
